<!-- eslint-disable -->
<template>
    <crm-dialog
        v-model="drawerVisible"
        :title="$t('menu.userInfo')"
        @close="dialogCancel"
        width="660px"
        :show-footer="false"
    >
        <template #context>
            <div>
                <el-form
                    v-if="drawerVisible"
                    class="form-container"
                    label-position="top"
                >
                    <el-form-item
                        style="width: 100%;"
                        :label="$t('users.avatar')"
                    >
                        <user-avatar :name="userInfo.base_info.email" />
                    </el-form-item>
                    <el-form-item
                        disabled
                        :label="$t('users.name')"
                    >
                        <el-input v-model="userInfo.base_info.real_name" disabled />
                    </el-form-item>
                    <el-form-item
                        disabled
                        :label="$t('users.userName')"
                    >
                        <el-input v-model="userInfo.base_info.user_name" disabled />
                        <!-- <span>{{ userInfo.base_info.user_name }}</span> -->
                    </el-form-item>
                    <el-form-item
                        disabled
                        :label="$t('users.baiduEmail')"
                    >
                        <el-input v-model="userInfo.base_info.email" disabled />
                    </el-form-item>
                    <el-form-item
                        disabled
                        :label="$t('users.belongDepartment')"
                    >
                        <el-input v-model="userInfo.org_info.org_name" disabled />
                    </el-form-item>
                    <el-form-item
                        disabled
                        :label="$t('users.departmentManagers')"
                    >
                        <el-input v-model="userInfo.org_info.org_leader" disabled />
                    </el-form-item>
                    <el-form-item
                        disabled
                        :label="$t('users.role')"
                        prop="role_id"
                    >
                        <el-input v-model="userInfo.role_info.role_name" disabled />
                    </el-form-item>
                    <el-form-item
                        disabled
                        :label="$t('common.cellPhone')"
                    >
                        <el-input v-model="userInfo.base_info.phone" disabled />
                    </el-form-item>
                    <el-form-item
                        disabled
                        :label="$t('common.gender')"
                        prop="sex"
                    >
                        <custom-select
                            disabled
                            v-model="userInfo.base_info.sex"
                            style="width: 100%"
                            need-translate
                            :options="sexList"
                        />
                        <!-- <span class="">{{ getSelectLabel('sex', userInfo.base_info.sex) }}</span> -->
                    </el-form-item>
                </el-form>
            </div>
        </template>
    </crm-dialog>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import CustomSelect from '@/components/custom-select/index.vue';
import UserAvatar from '@/components/avatar-box/index.vue';
import CrmDialog from '@/components/dialog/index.vue';
import { ElMessage } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { roleList, sexList } from '@/views/settings/department/consts';

const i18n = useI18n();
interface OptionItem {
  value: string | number;
  label: string;
}
type OptionType = 'sex' | 'role';

const emits = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        type: Boolean,
        default: () => {
            return true;
        }
    },
    userInfo: {
        type: Object,
        required: true,
        default: () => {
            return {}
        }
    }
});
const drawerVisible = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
const getSelectLabel = (type: OptionType, value: string | number) => {
    if (!type) {
        return value;
    }
    if (!value) {
        return '';
    }
    const options: {[key in OptionType]: OptionItem[]} = {
        sex: sexList as any[],
        role: roleList as any[]
    };
    const res = options[type].find((a: any) => a.value === value);
    return res && res.label ? i18n.t(res.label) : value;
};
const dialogCancel = () => {
    emits('update:modelValue', false);
};

</script>
<style scoped lang="scss">
.form-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-form-item {
        width: 47.3%;
        :deep(.el-form-item__label) {
            justify-content: flex-start;
        }
    }
}
</style>
